import React, { Component } from 'react'

const setArrayImmutable = (arr, i, value) => Object.assign([...arr], { [i]: value })

export class AccordionContainer extends Component {
  constructor() {
    super()
    this.state = { isOpen: [] }
    this.lastOpen = 0
  }

  toggleChild(childIndex) {
    let isOpen = [...this.state.isOpen]
    if (this.lastOpen !== childIndex) {
      isOpen = setArrayImmutable(isOpen, this.lastOpen, false)
      this.lastOpen = childIndex
    }
    this.setState({ isOpen: setArrayImmutable(isOpen, childIndex, !this.state.isOpen[childIndex]) })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.children.map(() => false) })
  }

  render() {
    return (
      <div>
        {this.props.children.map((expandable, index) =>
          React.cloneElement(expandable, {
            isOpen: this.state.isOpen[index],
            onClick: e => this.toggleChild(index),
            key: index,
          })
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/accordion.container.js